import BaseInteriorScene from "../BaseInteriorScene";
import gameHallSource from "./gameHall-source.json";
import { getVoidCityNpcDialogue } from "../../../@shared/utils/npcDialogs";
import interiorTiles32Png from "../../../@shared/assets/GameMaps/tilesets/interior/svoid-pr_fd_interior.png";
import interiorTiles16Png from "../../../@shared/assets/GameMaps/tilesets/interior/svoid-pr_fd_interior 16x16.png";
import interiorTiles32AltPng from "../../../@shared/assets/GameMaps/tilesets/interior/svoid-pr_fd_interior 32x32.png";
import cityBuildingTiles16Png from "../../../@shared/assets/GameMaps/tilesets/city/FDR_City_D_VOID.png";
import gameHallBg from "../GameMap/InfiNFT Maps/gameHall.png";

const GAME_HALL_EXIT_SPAWN = Object.freeze({ x: 912, y: 1130 });
const GAME_HALL_TILESET_CONFIGS = Object.freeze({
  "svoid-pr_fd_interior.tsx": {
    textureKey: "gameHallInterior32Base",
    image: interiorTiles32Png,
    imageWidth: 1024,
    frameWidth: 32,
    frameHeight: 32,
    columns: 32,
  },
  "svoid-pr_fd_interior 16x16.tsx": {
    textureKey: "gameHallInterior16",
    image: interiorTiles16Png,
    imageWidth: 512,
    frameWidth: 16,
    frameHeight: 16,
    columns: 32,
  },
  "svoid-pr_fd_interior 32x32.tsx": {
    textureKey: "gameHallInterior32Alt",
    image: interiorTiles32AltPng,
    imageWidth: 1024,
    frameWidth: 32,
    frameHeight: 32,
    columns: 32,
  },
  "FDR_City_D_VOID.tsx": {
    textureKey: "gameHallCityShell16",
    image: cityBuildingTiles16Png,
    imageWidth: 512,
    frameWidth: 16,
    frameHeight: 16,
    columns: 32,
  },
});
const GAME_HALL_LAYER_DEPTHS = Object.freeze([
  { name: "background", depth: 1 },
  { name: "floor", depth: 2 },
  { name: "floor2", depth: 3 },
  { name: "floor3", depth: 4 },
  { name: "walls", depth: 650 },
  { name: "decor", depth: 660 },
]);
const GAME_HALL_NPC_SPECS = Object.freeze([
  { textureKey: "interiorAmbientNpcB", x: 772, y: 434, facing: "down", scale: 2.0 },
  { textureKey: "interiorAmbientNpcA", x: 652, y: 516, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcE", x: 736, y: 516, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcC", x: 808, y: 516, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcD", x: 886, y: 516, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcC", x: 180, y: 452, facing: "right", scale: 1.95 },
  { textureKey: "interiorAmbientNpcE", x: 344, y: 572, facing: "left", scale: 1.95 },
  { textureKey: "interiorAmbientNpcA", x: 168, y: 726, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcC", x: 290, y: 726, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcE", x: 412, y: 726, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcD", x: 168, y: 864, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcB", x: 290, y: 864, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcA", x: 412, y: 864, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcA", x: 1048, y: 278, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcD", x: 1206, y: 278, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcB", x: 1348, y: 278, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcC", x: 1098, y: 420, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcE", x: 1280, y: 420, facing: "up", scale: 1.95 },
  { textureKey: "interiorAmbientNpcD", x: 1136, y: 790, facing: "down", scale: 1.95 },
  { textureKey: "interiorAmbientNpcA", x: 1308, y: 790, facing: "down", scale: 1.95 },
]);

export default class GameHallScene extends BaseInteriorScene {
  constructor() {
    super(
      "GameHallScene",
      BaseInteriorScene.extractCollisionDataFromMapSource(
        gameHallSource,
        "TestCollisions",
      ),
      gameHallBg,
      {
        exit: { to: "VoidCity2Scene", spawnAt: GAME_HALL_EXIT_SPAWN },
      },
      getVoidCityNpcDialogue,
      {
        mapSource: gameHallSource,
        mapTilesetConfigs: GAME_HALL_TILESET_CONFIGS,
        mapLayerDepths: GAME_HALL_LAYER_DEPTHS,
      },
    );
  }

  create(data) {
    super.create(data);

    const backgroundGuideLayer = gameHallSource.layers.find(
      (layer) => layer.type === "imagelayer" && layer.name === "BackgroundGuide",
    );
    if (backgroundGuideLayer?.visible !== false) {
      this.add
        .image(0, 0, `${this.scene.key}_bg`)
        .setOrigin(0)
        .setDepth(0);
    }

    GAME_HALL_NPC_SPECS.forEach((npc) => {
      this.createAmbientInteriorNpc(npc);
    });
  }
}
